import { z } from "zod";

export const selectPackageSchema = z.object({
  mobileNumber: z.string().regex(/(^[78]\d{6}$)|(^22[89]\d{4}$)/, {
    message:
      "Please enter a valid Brunei mobile phone number (e.g. 7/8xxxxxx, 228xxxx, 229xxxx)",
  }),
  package: z.object({
    id: z.number(),
    code: z.string().min(1, { message: "Package is required" }),
    price: z.string(),
  }),
});
